<app-side-menu>
  <div class="budget-proposal-view-content">
    <app-controladoria-nav></app-controladoria-nav>

    <header class="bpv-header">
      <div class="d-flex align-items-center flex-wrap gap-3">
        <button type="button" class="btn btn-outline-secondary" (click)="goBack()">
          <i class="fas fa-arrow-left me-2"></i>
          Voltar
        </button>
        <div>
          <h1 class="bpv-title mb-1">
            <i class="fas fa-file-invoice-dollar me-2"></i>
            Proposta de orçamento
            <span class="text-muted" *ngIf="proposal">#{{ proposal.id }}</span>
          </h1>
          <p class="text-muted mb-0">Detalhes da indicação de verba para o centro de custo.</p>
        </div>
        </div>
    </header>

    <div *ngIf="isLoading" class="text-center py-5">
      <i class="fas fa-spinner fa-spin fa-2x text-primary"></i>
      <p class="mt-3 text-muted">Carregando proposta...</p>
    </div>

    <div *ngIf="error && !isLoading" class="alert alert-danger d-flex justify-content-between align-items-center">
      <span><i class="fas fa-exclamation-triangle me-2"></i>{{ error }}</span>
      <button type="button" class="btn btn-outline-danger btn-sm" (click)="loadProposal()">
        <i class="fas fa-redo me-1"></i>
        Tentar novamente
      </button>
    </div>

    <div *ngIf="proposal && !isLoading" class="row g-4">
      <div class="col-12" *ngIf="canReviewProposal()">
        <div class="card shadow-sm border-warning bpv-review-card">
          <div class="card-body d-flex flex-column flex-md-row flex-md-wrap align-items-md-center justify-content-between gap-3">
            <div>
              <h5 class="mb-1"><i class="fas fa-gavel me-2"></i>Decisão da controladoria</h5>
              <p class="text-muted small mb-0">
                Esta proposta está pendente. Aprove ou recuse informando o parecer do gestor.
              </p>
            </div>
            <div class="d-flex flex-wrap gap-2" *appHasPermission="'CostCenters.Manage'">
              <button type="button" class="btn btn-success" (click)="openReviewModal('approve')">
                <i class="fas fa-check me-2"></i>
                Aprovar
              </button>
              <button type="button" class="btn btn-danger" (click)="openReviewModal('reject')">
                <i class="fas fa-times me-2"></i>
                Recusar
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12" *ngIf="!canReviewProposal() && (proposal.reviewComments || proposal.reviewedByStaffId)">
        <div class="card shadow-sm">
          <div class="card-header bg-white">
            <h5 class="mb-0"><i class="fas fa-gavel me-2"></i>Parecer da controladoria</h5>
          </div>
          <div class="card-body">
            <div class="row g-3">
              <div class="col-md-4" *ngIf="proposal.reviewedAt">
                <span class="bpv-label d-block">Analisado em</span>
                <span class="bpv-value">{{ formatDateTime(proposal.reviewedAt) }}</span>
              </div>
              <div class="col-md-4" *ngIf="proposal.reviewedByStaffId">
                <span class="bpv-label d-block">Analisado por</span>
                <span class="bpv-value">{{ reviewerName || ('Colaborador #' + proposal.reviewedByStaffId) }}</span>
              </div>
              <div class="col-12" *ngIf="proposal.reviewComments">
                <span class="bpv-label d-block">Comentário da análise</span>
                <p class="mb-0">{{ proposal.reviewComments }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="card h-100 shadow-sm">
          <div class="card-header bg-white">
            <h5 class="mb-0"><i class="fas fa-building me-2"></i>Centro de custo</h5>
          </div>
          <div class="card-body">
            <div class="bpv-field">
              <span class="bpv-label">Centro de custo</span>
              <span class="bpv-value">{{ getCostCenterLabel() }}</span>
            </div>
            <div class="bpv-field">
              <span class="bpv-label">Status</span>
              <span class="badge" [ngClass]="getStatusBadgeClass()">{{ getStatusLabel() }}</span>
            </div>
            <div class="bpv-field">
              <span class="bpv-label">Solicitado em</span>
              <span class="bpv-value">{{ formatDateTime(proposal.requestedAt) }}</span>
            </div>
            <div class="bpv-field mb-0">
              <span class="bpv-label">Solicitante</span>
              <span class="bpv-value">{{ requestedByName || (proposal.requestedByStaffId ? 'Colaborador #' + proposal.requestedByStaffId : '—') }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="card h-100 shadow-sm">
          <div class="card-header bg-white">
            <h5 class="mb-0"><i class="fas fa-coins me-2"></i>Valores propostos</h5>
          </div>
          <div class="card-body">
            <div class="bpv-field">
              <span class="bpv-label">Orçamento mensal proposto</span>
              <span class="bpv-value bpv-value--money">{{ formatMoney(proposal.proposedMonthlyBudget) }}</span>
            </div>
            <div class="bpv-field mb-0">
              <span class="bpv-label">Orçamento anual proposto</span>
              <span class="bpv-value bpv-value--money">{{ formatMoney(proposal.proposedAnnualBudget) }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card shadow-sm">
          <div class="card-header bg-white">
            <h5 class="mb-0"><i class="fas fa-align-left me-2"></i>Justificativa</h5>
          </div>
          <div class="card-body">
            <p class="mb-0">{{ proposal.justification || '—' }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-modal
    [isOpen]="reviewModalKind != null"
    [title]="getReviewModalTitle()"
    [size]="'md'"
    [closable]="!isReviewSubmitting"
    (close)="closeReviewModal()">
    <p class="text-muted small" *ngIf="reviewModalKind === 'approve'">
      Confirme a aprovação da proposta de orçamento para <strong>{{ getCostCenterLabel() }}</strong>.
    </p>
    <p class="text-muted small" *ngIf="reviewModalKind === 'reject'">
      Informe o motivo da recusa da proposta de orçamento para <strong>{{ getCostCenterLabel() }}</strong>.
    </p>
    <div class="mb-0">
      <label class="form-label">Comentário da análise <span class="text-danger">*</span></label>
      <textarea
        class="form-control"
        rows="4"
        [(ngModel)]="reviewComments"
        [disabled]="isReviewSubmitting"
        maxlength="2000"
        placeholder="Ex.: Aprovado conforme planejamento."></textarea>
    </div>
    <div slot="footer" class="d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-outline-secondary" [disabled]="isReviewSubmitting" (click)="closeReviewModal()">
        Cancelar
      </button>
      <button
        type="button"
        class="btn"
        [ngClass]="reviewModalKind === 'approve' ? 'btn-success' : 'btn-danger'"
        [disabled]="!canSubmitReview() || isReviewSubmitting"
        (click)="submitReview()">
        <i class="fas fa-spinner fa-spin me-1" *ngIf="isReviewSubmitting"></i>
        {{ reviewModalKind === 'approve' ? 'Confirmar aprovação' : 'Confirmar recusa' }}
      </button>
    </div>
  </app-modal>
</app-side-menu>
